module.exports = require("@material-ui/icons/ArrowUpward");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/icons/ArrowUpward"
// module id = 298
// module chunks = 0